import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["alt", "src"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { constants } from '@services/constants';
import { isAbortError, useAbort } from '@services/utils/abort-vue';
import { fetchImage, sticky } from './XImgCache';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'XImg',
},
  __name: 'XImg',
  props: {
    src: {},
    alt: { default: '' },
    svgTag: { type: Boolean, default: false }
  },
  emits: ["load", "error"],
  setup(__props: any, { emit: __emit }) {

const BLANK_IMG: string = constants.BLANK_IMG;



const props = __props;

const emit = __emit;

const dataSrc = ref(BLANK_IMG);
let blobLocked = false;
const abort = useAbort();

watch(
  () => props.src,
  () => {
    loadImage();
  },
);

onMounted(() => {
  loadImage();
});

onBeforeUnmount(() => {
  // Free up the blob if it was locked
  freeBlob();
});

const svg = computed(() => {
  if (props.svgTag && dataSrc.value.startsWith('data:image/svg+xml')) {
    return window.atob(dataSrc.value.split(',')[1]);
  }
  return null;
});

async function loadImage() {
  if (!props.src) return;

  // Free up current blob if it was locked
  freeBlob();

  // Just set src if not http
  if (props.src.startsWith('data:') || props.src.startsWith('blob:')) {
    dataSrc.value = props.src;
    return;
  }

  // Fetch image with worker
  try {
    const signal = abort.renew();
    const blobSrc = await fetchImage(props.src, { signal });
    signal.throwIfAborted();
    dataSrc.value = blobSrc;

    // Locking is needed primary for thumbnails,
    // since photoswipe uses the thumb url for the animated zoom-in
    lockBlob();
  } catch (error: any) {
    if (isAbortError(error)) return;
    dataSrc.value = BLANK_IMG;
    emit('error', error);
    console.error('Failed to load XImg', error);
  }
}

function load() {
  if (dataSrc.value === BLANK_IMG) return;
  emit('load', dataSrc.value);
}

function lockBlob() {
  sticky(dataSrc.value, 1);
  blobLocked = true;
}

function freeBlob() {
  if (!blobLocked) return;
  sticky(dataSrc.value, -1);
  blobLocked = false;
}

return (_ctx: any,_cache: any) => {
  return (svg.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "svg",
        innerHTML: svg.value
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        alt: __props.alt,
        src: dataSrc.value,
        onLoad: load
      }, null, 40, _hoisted_2))
}
}

})